module.exports = __webpack_public_path__ + "media/images/av-hori-fat_w500-e07156a527578679df3be5f54a1c4cf4.png";